module.exports = __webpack_public_path__ + "static/media/playBlack.0cc60bf7.png";